import React, { useState, useEffect } from 'react'
import InfoRow from '../components/InfoRow'
import SingleTextInputModal from '../components/modals/SafetyTailgateModals/SingleTextInputModal'
import LoadingSpinner from '../components/LoadingSpinner';
import { getUserByUid, updateUserByUid } from "../firebase";
import { BadgeOutlined, Mail } from '@mui/icons-material';
import Colors from '../colors';

function Account( {user} ) {
    const [firstName, setFirstName] = useState('')
    const [firstNameModalOpen, setFirstNameModalOpen] = useState(false)
    const [lastName, setLastName] = useState('')
    const [lastNameModalOpen, setLastNameModalOpen] = useState(false)
    const [email, setEmail] = useState('')
    const [loadingStatus, setLoadingStatus] = useState(true)

    const updateField = (field, value, setFunction) => {
        setFunction(value);
        updateUserByUid(user.uid, {[field]: value});
    }


    const updateFirstName = (newFirstName) => updateField('first_name', newFirstName, setFirstName)
    const updateLastName = (newLastName) => updateField('last_name', newLastName, setLastName)

    useEffect(() => {
        if (!user) return;
        const getUserData = async () => {
            const userData = await getUserByUid(user.uid);
            setFirstName(userData.first_name);
            setLastName(userData.last_name);
            setEmail(userData.email);
            setLoadingStatus(false);
        }
        getUserData();
    }, [user])

    return (
        <div style={{maxWidth: '500px', margin: '0 auto'}}>
            <LoadingSpinner isLoading={loadingStatus} />
            <InfoRow iconComponent={<BadgeOutlined sx={{color: Colors.green, fontSize: 35}}/>} title={'First Name'} mainText={firstName} isEditable onClickHandler={() => setFirstNameModalOpen(true)} />
            <InfoRow iconComponent={<BadgeOutlined sx={{color: Colors.green, fontSize: 35}}/>} title={'Last Name'} mainText={lastName} isEditable onClickHandler={() => setLastNameModalOpen(true)} />
            <InfoRow iconComponent={<Mail sx={{color: Colors.blue, fontSize: 35}}/>} title={'Email'} mainText={email}/>
            <SingleTextInputModal isVisible={firstNameModalOpen} setIsVisible={setFirstNameModalOpen} defaultValue={firstName} dataCallback={updateFirstName} modalLabel={'Update First Name'} inputLabel={'First Name'} />
            <SingleTextInputModal isVisible={lastNameModalOpen} setIsVisible={setLastNameModalOpen} defaultValue={lastName} dataCallback={updateLastName} modalLabel={'Update Last Name'} inputLabel={'Last Name'} />
        </div>
    )
}

export default Account